var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"dropzone"},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"dropzone-message"}},[_c('span',{staticClass:"dropzone-title"},[_vm._v(" "+_vm._s(_vm.translation.dropzone.video)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }